import React, { useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setAlert } from '../../../../store/actions';
import { ParentContext, ChildContext } from '../../Container/displayboardcontext';
import * as _ from 'lodash';
import { interval } from 'rxjs';

let subscribe;
let intervalCall;
const ThemeOneAlert: React.FC = () => {
    const dispatch = useDispatch();
    const context = useContext(ParentContext);
    const alertData = useSelector((state: any) => {
        if (state && state.displayBoardReducer && state.displayBoardReducer.alertToken)
            return state.displayBoardReducer.alertToken;
        else return undefined;
    });
    const alertAction = useSelector((state: any) => state?.displayBoardReducer?.alertTokensData?.length > 0);

    if (!alertData && alertAction) {
        intervalCall = setTimeout(() => {
            dispatch(setAlert());
        }, 1000);
    }


    useEffect(() => {
        // if (!subscribe)
        //     subscribe = interval(1000).subscribe(() => {
        //         dispatch(setAlert());
        //     });

        return () => {
            if (intervalCall)
                clearTimeout(intervalCall);
            // if (subscribe)
            //     subscribe.unsubscribe();
        }
    }, []);

    return (
        <>
            {alertData &&
                <ChildContext.Provider value={{ alertData: alertData, audioPath: context.audioPath }} >
                    <context.themeOnePopupAlert />
                </ChildContext.Provider>
            }
        </>
    )
}
export default React.memo(ThemeOneAlert);